import { createSlice } from "@reduxjs/toolkit"
import { VOICE_QUEUE_ANALYTICS } from "../../../../constants/reducer_names"

const initialState = {
    checked_column: [
        "Queue Name",
        "Inbound Calls",
        "Answered Calls",
        "Abandoned Calls",
        "Missed Calls",
        "Transferred Calls",
        "Average Queue Wait Time",
        "Maximum Queue Wait Time",
        "Talk Time",
        "Average Speed of Answer (ASA)",
        "Avg. Handle Time (AHT)",
        "Avg. Hold Time",
        "Maximum Handle Time",
        "Total ACW Time",
        "Avg. Hold Time",
        "Occupancy Rate (%)",
        "First Call Resolution (%)",
        "Customer Satisfaction (%)"
    ] as any,
    checked_column2: [
        "Queue Name",
        "Outbound Calls",
        "Answered Calls",
        "Unanswered Calls",
        "Abandoned Calls",
        "Transferred Calls",
        "UnAnswered calls",
        "Average Speed of Answer (ASA)",
        "Avg. Handle Time (AHT)",
        "Maximum Handle Time",
        "ACW Time",
        "Avg. Hold Time",
        "Occupancy Rate (%)",
        "First Call Resolution (%)",
        "Customer Satisfaction (%)",
    ] as any,
    checked_column3: [
        "Queue Name",
        "Callbacks Received",
        "Callbacks Returned",
        "Callbacks Answered",
        "Callbacks Unanswered",
        "Abandoned Callbacks",
        "Callback Duration",
        "Avg. Handle Time (AHT)",
        "Maximum Handle Time",
        "Overall Conversion Rate",
        "Callback Success Rate"
    ] as any,
    checked_column4: [
        "Queue Name",
        "Voicemails Received",
        "Voicemails Responded",
        "Voicemails Not Responded",
        "Total Length of Voicemails",
        "Avg. Length of Voicemails"
    ] as any,
    checked_column5: [
        // "Time",
        "Queue",
        "Outbound calls",
        "Answered Calls",
        "UnAnswered calls",
        "Success Rate",
        "Right party"
    ] as any,
    checked_column6: [
        "Queue Name",
        "Call Type",
        "SL1",
        "SL2",
        "SL3",
        "SL4",
        "SL5",
        "SL6",
        "Total SLA",
        "Missed Calls",
        "Answered call",
        "SLA Achieved (%)",
        "SLA Breached (%)"
    ] as any,
    titleMapper_ForDb: {
        "Queue Name": "queueName",
        "Inbound Calls": "inboundcalls",
        "Answered Calls": "answeredCalls",
        "Abandoned Calls": "abandonedCalls",
        "Missed Calls": "missedCalls",
        "Transferred Calls": "transferredCalls",
        "Average Queue Wait Time": "averageQueueWaitTime",
        "Maximum Queue Wait Time": "maxiumQueueWaitTime",
        "Talk Time": "talktime",
        "Average Speed of Answer (ASA)": "avgSpeedofAnswer",
        "Avg. Handle Time (AHT)": "averageHandleTime",
        "Maximum Handle Time": "maximumHandleTime",
        "Total ACW Time": "totalACWTime",
        "Avg. Hold Time": "averageHoldTime",
        "Occupancy Rate (%)": "occupancyrate",
        "First Call Resolution (%)": "firstCallResolution",
        "Customer Satisfaction (%)": "customersatisfaction"
    } as any,
    titleMapper_ForDb2: {
        "Queue Name": "queueName",
        "Outbound Calls": "outboundcalls",
        "Answered Calls": "answeredCalls",
        "Unanswered Calls": "unAnsweredCalls",
        "Abandoned Calls": "abandonedCalls",
        "Transferred Calls": "transferredCalls",
        "Average Speed of Answer (ASA)": "avgSpeedofAnswer",
        "Avg. Handle Time (AHT)": "averageHandleTime",
        "Maximum Handle Time": "maximumHandleTime",
        "ACW Time": "totalACWTime",
        "Avg. Hold Time": "averageHoldTime",
        "Occupancy Rate (%)": "occupancyrate",
        "First Call Resolution (%)": "firstCallResolution",
        "Customer Satisfaction (%)": "customersatisfaction",
    } as any,
    titleMapper_ForDb3: {
        "Queue Name": "queueName",
        "Callbacks Received": "callBackReceived",
        "Callbacks Returned": "callBackReturend",
        "Callbacks Answered": "callBackAnswered",
        "Callbacks Unanswered": "callBackUnanswered",
        "Abandoned Callbacks": "abandonedCallback",
        "Callback Duration": "callBackDuration",
        "Avg. Handle Time (AHT)": "avgHandlingTime",
        "Maximum Handle Time": "maxHandlingTime",
        "Overall Conversion Rate": "overallConversationRate",
        "Callback Success Rate": "callbackSuccessRate"
    } as any,
    titleMapper_ForDb4: {
        "Queue Name": "queueName",
        "Voicemails Received": "VoicemailReceived",
        "Voicemails Responded": "VoicemailResponded",
        "Voicemails Not Responded": "VoicemailNotResponded",
        "Total Length of Voicemails": "Total_voicemail_length",
        "Avg. Length of Voicemails": "Avg_voicemail_length",
    } as any,
    titleMapper_ForDb5: {
        "Time":"Time",
        "Queue":"queueName",
        "Outbound Calls":"outboundcalls",
        "Answered":"answeredCalls",
        "Unanswered":"unAnsweredCalls",
        "Success Rate":"SucessRate"
    } as any,
    titleMapper_ForDb6: {
        "Queue Name": "queueName",
        "Call Type": "queueName",
        "SL1": "SL1",
        "SL2": "SL2",
        "SL3": "SL3",
        "SL4": "SL4",
        "SL5": "SL5",
        "SL6": "SL6",
        "Total": "TotalSLA",
        "Missed Calls": "MissedCalls",
        "SLA Achieved (%)": "SLAAchieved",
        "SLA Breached (%)": "SLAbreached"
    } as any,
    updated_TableColumn: [
        {
            title: "Queue Name",
            dataIndex: 'queueName',
            key: 'queueName',
        },
        {
            title: 'Inbound Calls',
            dataIndex: 'inboundcalls',
            key: 'inboundcalls',
        },
        {
            title: 'Answered Calls',
            dataIndex: 'answeredCalls',
            key: 'answeredCalls',
        },
        {
            title: 'Abandoned Calls',
            dataIndex: 'abandonedCalls',
            key: 'abandonedCalls',
        },
        {
            title: 'Missed Calls',
            dataIndex: 'missedCalls',
            key: 'missedCalls',
        },
        {
            title: 'Transferred Calls',
            dataIndex: 'transferredCalls',
            key: 'transferredCalls',
        },
        {
            title: "Average Queue Wait Time",
            dataIndex: 'averageQueueWaitTime',
            key: 'averageQueueWaitTime',
        },
        {
            title: "Maximum Queue Wait Time",
            dataIndex: 'maxiumQueueWaitTime',
            key: 'maxiumQueueWaitTime',
        },
        {
            title: 'Talk Time',
            dataIndex: 'talktime',
            key: 'talktime',
        },
        {
            title: 'Average Speed of Answer (ASA)',
            dataIndex: 'avgSpeedofAnswer',
            key: 'avgSpeedofAnswer',
        },
        {
            title: 'Avg. Handle Time (AHT)',
            dataIndex: 'averageHandleTime',
            key: 'averageHandleTime',
        },
        {
            title: 'Maximum Handle Time',
            dataIndex: 'maximumHandleTime',
            key: 'maximumHandleTime',
        },
        {
            title: 'Total ACW Time',
            dataIndex: 'totalACWTime',
            key: 'totalACWTime',
        },
        {
            title: 'Avg. Hold Time',
            dataIndex: 'averageHoldTime',
            key: 'averageHoldTime',
        },
        {
            title: 'Occupancy Rate (%)',
            dataIndex: 'occupancyrate',
            key: 'occupancyrate',
        },
        {
            title: 'First Call Resolution (%)',
            dataIndex: 'firstCallResolution',
            key: 'firstCallResolution',
        },
        {
            title: 'Customer Satisfaction (%)',
            dataIndex: 'customersatisfaction',
            key: 'customersatisfaction',
        }
    ] as any,
    updated_TableColumn2: [
        {
            title: 'Queue Name',
            dataIndex: 'queueName',
            key: 'queueName',
        },
        {
            title: 'Outbound Calls',
            dataIndex: 'outboundcalls',
            key: 'outboundcalls',
        },
        {
            title: 'Answered Calls',
            dataIndex: 'answeredCalls',
            key: 'answeredCalls',
        },
        {
            title: 'Unanswered Calls',
            dataIndex: 'unAnsweredCalls',
            key: 'unAnsweredCalls',
        },
        {
            title: 'Abandoned Calls',
            dataIndex: 'abandonedCalls',
            key: 'abandonedCalls',
        },
        {
            title: 'Transferred Calls',
            dataIndex: 'transferredCalls',
            key: 'transferredCalls',
        },
        {
            title: 'Average Speed of Answer (ASA)',
            dataIndex: 'avgSpeedofAnswer',
            key: 'avgSpeedofAnswer',
        },
        {
            title: 'Avg. Handle Time (AHT)',
            dataIndex: 'averageHandleTime',
            key: 'averageHandleTime',
        },
        {
            title: 'Maximum Handle Time',
            dataIndex: 'maximumHandleTime',
            key: 'maximumHandleTime',
        },
        {
            title: 'ACW Time',
            dataIndex: 'totalACWTime',
            key: 'totalACWTime',
        },
        {
            title: 'Avg. Hold Time',
            dataIndex: 'averageHoldTime',
            key: 'averageHoldTime',
        },
        {
            title: 'Occupancy Rate (%)',
            dataIndex: 'occupancyrate',
            key: 'occupancyrate',
        },
        {
            title: 'First Call Resolution (%)',
            dataIndex: 'firstCallResolution',
            key: 'firstCallResolution',
        },
        {
            title: 'Customer Satisfaction (%)',
            dataIndex: 'customersatisfaction',
            key: 'customersatisfaction',
        },
    ] as any,
    updated_TableColumn3: [
        {
            title: 'Queue Name',
            dataIndex: 'queueName',
            key: 'queueName',
        },
        {
            title: 'Callbacks Received',
            dataIndex: 'callBackReceived',
            key: 'callBackReceived',
        },
        {
            title: 'Callbacks Returned',
            dataIndex: 'callBackReturend',
            key: 'callBackReturend',
        },
        {
            title: 'Callbacks Answered',
            dataIndex: 'callBackAnswered',
            key: 'callBackAnswered',
        },
        {
            title: 'Callbacks Unanswered',
            dataIndex: 'callBackUnanswered',
            key: 'callBackUnanswered',
        },
        {
            title: 'Abandoned Callbacks',
            dataIndex: 'abandonedCallback',
            key: 'abandonedCallback',
        },
        {
            title: 'Callback Duration',
            dataIndex: 'callBackDuration',
            key: 'callBackDuration',
        },
        {
            title: 'Avg. Handle Time (AHT)',
            dataIndex: 'avgHandlingTime',
            key: 'avgHandlingTime',
        },
        {
            title: 'Maximum Handle Time',
            dataIndex: 'maxHandlingTime',
            key: 'maxHandlingTime',
        },
        {
            title: 'Overall Conversion Rate',
            dataIndex: 'overallConversationRate',
            key: 'overallConversationRate',
        },
        {
            title: 'Callback Success Rate',
            dataIndex: 'callbackSuccessRate',
            key: 'callbackSuccessRate',
        },
    ] as any,
    updated_TableColumn4: [
        {
            title: 'Queue Name',
            dataIndex: 'queueName',
            key: 'queueName',
        },
        {
            title: 'Voicemails Received',
            dataIndex: 'VoicemailReceived',
            key: 'VoicemailReceived',
        },
        {
            title: 'Voicemails Responded',
            dataIndex: 'VoicemailResponded',
            key: 'VoicemailResponded',
        },
        {
            title: 'Voicemails Not Responded',
            dataIndex: 'VoicemailNotResponded',
            key: 'VoicemailNotResponded',
        },
        {
            title: 'Total Length of Voicemails',
            dataIndex: 'Total_voicemail_length',
            key: 'Total_voicemail_length',
        },
        {
            title: 'Avg. Length of Voicemails',
            dataIndex: 'Total_voicemail_length',
            key: 'Total_voicemail_length',
        },
    ] as any,
    updated_TableColumn5: [
        {
            title: 'Time',
            dataIndex: 'Time',
            key: 'Time',
        },
        {
            title: 'Queue',
            dataIndex: 'queueName',
            key: 'queueName',
        },
        {
            title: 'Outbound Calls',
            dataIndex: 'outboundcalls',
            key: 'outboundcalls',
        },
        {
            title: 'Answered',
            dataIndex: 'answeredCalls',
            key: 'answeredCalls',
        },
        {
            title: 'Unanswered',
            dataIndex: 'unAnsweredCalls',
            key: 'unAnsweredCalls',
        },
        {
            title: 'Success Rate',
            dataIndex: 'SucessRate',
            key: 'SucessRate',
        }
    ] as any,
    updated_TableColumn6: [
        {
            title: 'Queue Name',
            dataIndex: 'queueName',
            key: 'queueName',
        },
        {
            title: 'Call Type',
            dataIndex: 'queueName',
            key: 'queueName',
        },
        {
            title: 'SL1',
            dataIndex: 'SL1',
            key: 'SL1',
        },
        {
            title: 'SL2',
            dataIndex: 'SL2',
            key: 'SL3',
        },
        {
            title: 'SL3',
            dataIndex: 'SL3',
            key: 'SL3',
        },
        {
            title: 'SL4',
            dataIndex: 'SL4',
            key: 'SL4',
        },
        {
            title: 'SL5',
            dataIndex: 'SL5',
            key: 'SL5',
        },
        {
            title: 'SL6',
            dataIndex: 'SL6',
            key: 'SL6',
        },
        {
            title: 'Total',
            dataIndex: 'TotalSLA',
            key: 'TotalSLA',
        },
        {
            title: 'Missed Calls',
            dataIndex: 'MissedCalls',
            key: 'MissedCalls',
        },
        {
            title: 'SLA Achieved (%)',
            dataIndex: 'SLAAchieved',
            key: 'SLAAchieved',
        },
        {
            title: 'SLA Breached (%)',
            dataIndex: 'SLAbreached',
            key: 'SLAbreached',
        },
    ] as any,
    queueVoicePdf: false,
}

const queueAnalyticsVoiceSlice = createSlice({
    name: VOICE_QUEUE_ANALYTICS,
    initialState,
    reducers: {
        checkedColumn: (state, { payload }) => {
            state.checked_column = payload.checked_column;
        },
        checkedColumn2: (state, { payload }) => {
            state.checked_column2 = payload.checked_column2;
        },
        checkedColumn3: (state, { payload }) => {
            state.checked_column3 = payload.checked_column3;
        },
        checkedColumn4: (state, { payload }) => {
            state.checked_column4 = payload.checked_column4;
        },
        checkedColumn5: (state, { payload }) => {
            state.checked_column5 = payload.checked_column5;
        },
        checkedColumn6: (state, { payload }) => {
            state.checked_column6 = payload.checked_column6;
        },
        titleMapperForDb: (state, { payload }) => {
            state.titleMapper_ForDb = payload.titleMapper_ForDb;
        },
        titleMapperForDb2: (state, { payload }) => {
            state.titleMapper_ForDb2 = payload.titleMapper_ForDb2;
        },
        titleMapperForDb3: (state, { payload }) => {
            state.titleMapper_ForDb3 = payload.titleMapper_ForDb3;
        },
        titleMapperForDb4: (state, { payload }) => {
            state.titleMapper_ForDb4 = payload.titleMapper_ForDb4;
        },
        titleMapperForDb5: (state, { payload }) => {
            state.titleMapper_ForDb5 = payload.titleMapper_ForDb5;
        },
        titleMapperForDb6: (state, { payload }) => {
            state.titleMapper_ForDb6 = payload.titleMapper_ForDb6;
        },
        updatedTableColumn: (state, { payload }) => {
            state.updated_TableColumn = payload.updated_TableColumn;
        },
        updatedTableColumn2: (state, { payload }) => {
            state.updated_TableColumn2 = payload.updated_TableColumn2;
        },
        updatedTableColumn3: (state, { payload }) => {
            state.updated_TableColumn3 = payload.updated_TableColumn3;
        },
        updatedTableColumn4: (state, { payload }) => {
            state.updated_TableColumn4 = payload.updated_TableColumn4;
        },
        updatedTableColumn5: (state, { payload }) => {
            state.updated_TableColumn5 = payload.updated_TableColumn5;
        },
        updatedTableColumn6: (state, { payload }) => {
            state.updated_TableColumn6 = payload.updated_TableColumn6;
        },
        setqueueVoicePdf: (state, { payload }) => {
            state.queueVoicePdf = payload;
        },
    }
})

export const queueAnalyticsVoiceSliceActions = queueAnalyticsVoiceSlice.actions;
export const queueAnalyticsVoiceSliceReducer = queueAnalyticsVoiceSlice.reducer